import styled from 'styled-components';

export const IncentivesSectionStyle = styled.section`
	.section-title {
		margin-bottom: 16px;
		display: flex;
		align-items: center;
	}

	.incentives-wrapper {
		display: flex;
		flex-direction: column;
		gap: 16px;
		width: 100%;
	}
`;
